

export default (function () {

    var init = function () {
        const $button = document.getElementById('gift-aid-button');
        const $textArea = document.getElementById('gift-aid-text-area');

        if (!$button || !$textArea) {
            return;
        }

        const initialchecked = $button.checked;

        $textArea.required = initialchecked;
        $textArea.style.display = initialchecked ? "block" : "none";

        $button.addEventListener('click', e => {
            const checked = e.target.checked; 
            checked ? $textArea.required = true : $textArea.removeAttribute("required");
            $textArea.style.display = checked ? "block" : "none";
        });
    };


    return {
        init: init
    };
})();


